module.exports = __webpack_public_path__ + "static/media/image.3d0b31ed.png";